module.exports = __webpack_public_path__ + "static/img/a012.2caeb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a012.jpg
// module id = 7S4Q
// module chunks = 0